export default __webpack_public_path__ + "static/media/question-mark.9caa5b96.svg";